export default "__VITE_ASSET__Dp7bWcPg__"